export default __webpack_public_path__ + "static/media/productBanner.992f9a32.jpg";